// AB 分流工具：自然日内固定（cookie）
// - 同一用户同一天固定在同一个桶
// - 次日重新分桶
// - 只做“分桶”，具体业务（图片/打点等）由调用方映射

function getTodayStr(fallbackDate = new Date()) {
  // 兼容项目内“自然日”口径（优先 utils.date.FormatDate）
  try {
    // eslint-disable-next-line global-require
    const { utils } = require('@/libs/interfaces')
    if (utils?.date?.FormatDate) return utils.date.FormatDate(new Date())
  } catch (e) {
    // ignore
  }
  const d = fallbackDate
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

function getUtilsCookie() {
  try {
    // eslint-disable-next-line global-require
    const { utils } = require('@/libs/interfaces')
    return utils?.cookie
  } catch (e) {
    return null
  }
}

/**
 * 获取自然日内固定的分桶 index
 * @param {string} storageKey 业务 key（建议全局唯一）
 * @param {string} uid 用户标识（unionid/openid 等）
 * @param {number} bucketCount 桶数量（默认 2）
 * @returns {number} index: 0..bucketCount-1
 */
export function getDailyStickyBucketIndex(storageKey, uid, bucketCount = 2) {
  const safeBucketCount = Number(bucketCount) > 0 ? Number(bucketCount) : 2
  const today = getTodayStr()
  const key = `${storageKey}_${uid || 'na'}`
  const cookie = getUtilsCookie()

  try {
    const raw = cookie?.getCookie ? cookie.getCookie(key) : ''
    const parsed = raw ? JSON.parse(raw) : null
    if (parsed && parsed.d === today && typeof parsed.i === 'number' && parsed.i >= 0 && parsed.i < safeBucketCount) return parsed.i
  } catch (e) {
    // ignore
  }

  const idx = Math.floor(Math.random() * safeBucketCount)
  try {
    // 过期时间按“自然日”口径：给 1 天即可，日期校验会确保跨天失效
    if (cookie?.setCookie) cookie.setCookie(JSON.stringify({ d: today, i: idx }), 1, key)
  } catch (e) {
    // ignore
  }
  return idx
}

function getAbtestHost() {
  // AB 分流域名：预发布/非生产走 apoerp，线上走 apollo
  return process.env.NODE_ENV === 'production' ? 'https://apollo.ktvsky.com' : 'https://apoerp.ktvsky.com'
}

function getHttpClient() {
  try {
    // eslint-disable-next-line global-require
    const { http } = require('@/libs/interfaces')
    return http
  } catch (e) {
    return null
  }
}

function getLodashGet() {
  try {
    // eslint-disable-next-line global-require
    return require('lodash/get')
  } catch (e) {
    return null
  }
}

/**
 * Apollo AB 测分组（服务端分流）
 * @param {Object} args
 * @param {string} args.experiment_id 实验 id
 * @param {string} args.unionid 用户 unionid
 * @param {string=} args.host 指定 host（默认按环境自动选择）
 * @returns {Promise<'A'|'B'>}
 */
export async function getApolloAbGroup({ experiment_id, unionid, host } = {}) {
  if (!experiment_id || !unionid) return 'A'
  const http = getHttpClient()
  const lodashGet = getLodashGet()
  if (!http || !lodashGet) return 'A'

  try {
    const res = await http.get(`${host || getAbtestHost()}/apollo/abtest`, {
      params: { experiment_id, unionid },
    })
    const group = lodashGet(res, 'data.data.group', 'A')
    return String(group || 'A').toUpperCase() === 'B' ? 'B' : 'A'
  } catch (e) {
    return 'A'
  }
}

/**
 * Apollo AB 测接口：获取分组与配置
 * @param {string} experiment_id 实验 id（业务侧传入）
 * @param {string} unionid 用户标识（允许传 openid）
 * @returns {Promise<{ group: string, config: any, raw: any }>}
 */
export async function getApolloAbtestResult(experiment_id, unionid) {
  let group = 'A'
  let config = null
  let raw = null
  if (!experiment_id || !unionid) return { group, config, raw }
  try {
    // eslint-disable-next-line global-require
    const { http } = require('@/libs/interfaces')
    const res = await http.get(`${getAbtestHost()}/apollo/abtest`, {
      params: {
        experiment_id,
        unionid,
      },
    })
    raw = res
    const dataGroup = res?.data?.data?.group
    group = String(dataGroup || 'A').toUpperCase()
    config = res?.data?.data?.toastConfig ?? res?.data?.data?.config ?? null
  } catch (e) {
    group = 'A'
    config = null
    raw = null
  }
  return { group, config, raw }
}
